module.exports = __webpack_public_path__ + "public/adminIcons/ce2b5b26.svg?ce2b5b26";